import React, { useState } from "react";
import { Activity, Team } from "../types";
import ActivityItem from "./Activity";
import { useCollectionData } from "react-firebase-hooks/firestore";
import {
  addDoc,
  increment,
} from "firebase/firestore";
import OpenedActivity from "./OpenedActivity";
import { updateDoc } from "firebase/firestore";
import { activityRef, getTeamname, getUsername, livefeedRef, teamRef } from "../utils";





function Activities() {
  
  const [data] = useCollectionData<Activity>(activityRef);
  const firebaseActivities = data ?? [];

  const [openedActivityId, setOpenedActivityId] = useState<string>();

  
  const [teamData] = useCollectionData<Team>(teamRef);
  const firebaseTeams = teamData ?? [];

  const openActivityModal = (activity: Activity) => {
    setOpenedActivityId(activity.id);
  };
  const handleClaim = async () => {
    const team = getTeam(getUsername());
    if (!team || !openedActivityId) {
      return;
    }
    const activity = getActivity(openedActivityId);
    await updateDoc(activity.ref, {
      status: "claimed",
      claimedBy: getUsername(),
    });
    await updateDoc(team.ref, {
      activity: activity.id,
    });
    await addDoc(livefeedRef, {
      text: getTeamname(team.teamName)+" claimet "+activity.title+" verdt "+activity.points+" points!!",
      timestamp: Date.now(),
      type: "CLAIM",
    })
  };

  const handleApprove = async () => {
    const team = getTeam(getUsername());
    if (!team || !openedActivityId) {
      return;
    }
    const activity = getActivity(openedActivityId);
    await updateDoc(team.ref, {
      activity: "",
      points: increment(activity.points),
    });
    await updateDoc(activity.ref, {
      status: "finished",
    });
    await addDoc(livefeedRef, {
      text: getTeamname(team.teamName)+" fikk nettopp "+activity.title+" approved og tjente "+activity.points+" points!!",
      timestamp: Date.now(),
      type: "APPROVE",
    })
  };

  const handleAbort = async () => {
    const team = getTeam(getUsername());
    if (!team || !openedActivityId) {
      return;
    }
    const activity = getActivity(openedActivityId);
    await updateDoc(team.ref, {
      activity: "",
      points: (team.points -= activity.points / 2),
    });
    await updateDoc(activity.ref, {
      status: "available",
      claimedBy: "",
    });
    await addDoc(livefeedRef, {
      text: getTeamname(team.teamName)+" feiger ut på oppgaven "+activity.title+" og mister "+activity.points+" points!! Alle ler av "+team.teamName,
      timestamp: Date.now(),
      type: "ABORT",
    })
  };

  const getActivity = (id: string) => {
    const activity = firebaseActivities.find((activity) => activity.id === id);
    if (!activity) {
      throw Error();
    }
    return activity;
  };

  const getTeam = (id: string | null) => {
    const team = firebaseTeams.find((team) => team.teamName === id);
    if (!team) {
      return;
    }
    return team;
  };

  const availableActivities = firebaseActivities
    .filter((activity) => activity.status === "available")
    .sort((a, b) => b.points - a.points);
  const claimedActivites = firebaseActivities
    .filter((activity) => activity.status === "claimed")
    .sort((a, b) => b.points - a.points);
  const finishedActivities = firebaseActivities
    .filter((activity) => activity.status === "finished")
    .sort((a, b) => b.points - a.points);
  return (
    <div className="activities">
      {openedActivityId && (
        <OpenedActivity
          team={getTeam(getUsername())}
          activity={getActivity(openedActivityId)}
          onClose={() => setOpenedActivityId(undefined)}
          onClaim={handleClaim}
          onApprove={handleApprove}
          onAbort={handleAbort}
        />
      )}
      <span className="activity-section-text">
        <p>Available</p>
      </span>

      {availableActivities.length > 0 ? (
        availableActivities.map((activity) => (
          <ActivityItem
            key={activity.title}
            activity={activity}
            onClick={() => openActivityModal(activity)}
          />
        ))
      ) : (
        <p>No more available tasks.</p>
      )}
      <span className="activity-section-text">
        <p>Claimed</p>
      </span>
      {claimedActivites.length > 0 ? (
        claimedActivites.map((activity) => (
          <ActivityItem
            key={activity.title}
            activity={activity}
            onClick={() => openActivityModal(activity)}
          />
        ))
      ) : (
        <p>Nothing claimed yet..</p>
      )}
      <span className="activity-section-text">
        <p>Finished</p>
      </span>
      {finishedActivities.length > 0 ? (
        finishedActivities.map((activity) => (
          <ActivityItem
            key={activity.title}
            activity={activity}
            onClick={() => openActivityModal(activity)}
          />
        ))
      ) : (
        <p>Nothing finished yet..</p>
      )}
    </div>
  );
}

export default Activities;
